const urlFilterRegex = /^filter\.(.*)/

export function filterToQueryField(entity, filter) {
    if (entity === filter.entityName) {
        return filter.optionsField
    }

    return `${filter.entityName}__${filter.optionsField}`
}

/**
 * Turns a passed filters object into a url search string.
 * If you pass currentSearchString, non-filter params will be kept in the url.
 * Otherwise they are discarded.
 * @param filters
 * @param searchTerm
 * @param filterId
 * @param currentSearchString
 * @returns {string}
 */
export function filtersToUrl(
    filters,
    searchTerm,
    filterId,
    currentSearchString
) {
    let urlParams = new URLSearchParams()

    Object.entries(filters).forEach(([field, value]) => {
        // If the value is not null, undefined, or an empty string
        if (value.length) {
            urlParams.append(`filter.${field}`, JSON.stringify(value))
        }
    })
    if (searchTerm) {
        urlParams.append(`filter.search`, JSON.stringify(searchTerm))
    }
    if (filterId) {
        urlParams.append(`filterId`, filterId)
    }

    if (currentSearchString) {
        const currentSearchParams = new URLSearchParams(currentSearchString)
        currentSearchParams.forEach((value, key) => {
            if (!urlFilterRegex.test(key) && key !== 'filterId') {
                urlParams.append(key, value)
            }
        })
    }

    // the URLSearchParams takes care of URL encoding.
    return urlParams.toString()
}

export function urlToFilters(entity, filters, urlParams) {
    const result = {}
    let searchTerm = ''
    let savedFilter = null

    // This url decodes for us and strips leading '?'s.
    urlParams = new URLSearchParams(urlParams)
    urlParams.forEach((value, key) => {
        if (key === 'filterId') {
            savedFilter = value
            return
        }

        // strip the "filter." part, use only the rest of the string in the capture group
        let matches = key.match(urlFilterRegex)
        if (matches && matches.length > 1) {
            if (matches[1] === 'search') searchTerm = JSON.parse(value)
            else result[matches[1]] = JSON.parse(value)
        }
    })
    return { filters: result, searchTerm, savedFilter }
}

const filtersObject = {
    urlToFilters,
    filtersToUrl,
    filterToQueryField,
}

export default filtersObject
